export const verticalCarousel = () => {
  const scrollArea = document.getElementById('vertical-carousel_slides');
  if (scrollArea) {
    scrollArea.addEventListener('touchstart', () => {
      if (!isTouchedBottom(scrollArea) && !isTouchedTop(scrollArea)) {
        scrollArea.style.overscrollBehavior = 'none';
      } else {
        scrollArea.style.overscrollBehavior = 'auto';
      }
    });

    scrollArea.addEventListener('touchend', () => {
      if (isTouchedBottom(scrollArea) || isTouchedTop(scrollArea)) {
        scrollArea.style.overscrollBehavior = 'auto';
      } else {
        scrollArea.style.overscrollBehavior = 'none';
      }
    });
  }

  const isTouchedTop = (el) => {
    return el.scrollTop === 0;
  }
  const isTouchedBottom = (el) => {
    return (el.scrollTop + el.clientHeight) === el.scrollHeight;
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/vertical-carousel/vertical-carousel.js